<div class="ai-dialog-header">
    <ng-template #default>
        <span>{{ title() }}</span>

        <ai-button
            [transparent]="true"
            [shape]="'round'"
            [border]="'hidden'"
            (click)="onClose($event)"
        >
            <ai-icon [fontIcon]="'ai-icon-cancel'"></ai-icon>
        </ai-button>
    </ng-template>

    <ng-container
        *ngTemplateOutlet="headerTemplate() ?? default"
    ></ng-container>
</div>
